import { useUser } from "src/common/context/userContextUtils";
import { COMPANYADMIN, SUPERADMIN } from "src/common/service/users";
import { isEox7Configured } from "src/env";

/** Mirrors eox7's `hasAccessToCompanyDomain` only; eox7 may still refuse to provision a report user (see `getMyDocuments`). */
export function useHasExcelReportAccess(companyDomainId: string): boolean {
	const user = useUser();
	return (
		isEox7Configured &&
		user.hasPermissions(
			companyDomainId,
			["ExopenForExcel", COMPANYADMIN, SUPERADMIN],
			"any",
		)
	);
}
